/* eslint-disable no-restricted-imports */
import {Sound} from '../../utils/sound.ts'
import {type GameModeTranslationKeyContext, type TranslationObject} from '@colonist/i18n'
import {type PlayerColor} from '@colonist/game-states'
import IconLargestArmyHighlight from '@static/images/icon_largest_army_highlight.svg'
import IconLongestRoadHighlight from '@static/images/icon_longest_road_highlight.svg'
import ImageMetropolisTrade from '@static/images/metropolis_trade.svg'
import ImageMetropolisScience from '@static/images/metropolis_science.svg'
import IconTradeHouse from '@static/images/icon_tradehouse.svg'
import IconAqueduct from '@static/images/icon_aqueduct.svg'
import IconFortress from '@static/images/icon_fortress.svg'
import {UIImagePathController} from '../../../../../code/client/shared/scripts/UIEnums.ts'
import ImageMetropolisPolitics from '@static/images/metropolis_politics.svg'
import {type ImageURL} from '@colonist/types'

export const GAME_ACHIEVEMENT_TYPES = ['LargestArmy', 'LongestRoad', 'MetropolisTrade', 'MetropolisPolitics', 'MetropolisScience', 'TradingHouse', 'Aqueduct', 'Fortress'] as const
export type GameAchievementType = typeof GAME_ACHIEVEMENT_TYPES[number]

export const getAchievementData = (achievementType: GameAchievementType,
                                   playerColor: PlayerColor,
                                   context?: GameModeTranslationKeyContext): {
    victoryPointChange?: number
    title: TranslationObject
    subTitle?: TranslationObject
    soundType?: Sound.SoundType
    icon: ImageURL
    subIcon?: ImageURL
} => {
    switch(achievementType) {
        case 'LargestArmy':
            return {
                victoryPointChange: 2,
                title: {key: 'strings:game.playerInformation.largestArmy.title'},
                soundType: Sound.SoundType.AchievementLargestArmy,
                icon: IconLargestArmyHighlight,
            }
        case 'LongestRoad':
            return {
                victoryPointChange: 2,
                title: {key: 'strings:game.playerInformation.longestRoad.title', options: {context: context}},
                soundType: Sound.SoundType.AchievementLongestRoad,
                icon: IconLongestRoadHighlight,
            }

        case 'MetropolisTrade':
            return {
                victoryPointChange: 2,
                title: {key: 'strings:game.achievements.title.metropolis.Trade'},
                icon: UIImagePathController.citiesByColor[playerColor],
                subIcon: ImageMetropolisTrade,
            }
        case 'MetropolisPolitics':
            return {
                victoryPointChange: 2,
                title: {key: 'strings:game.achievements.title.metropolis.Politics'},
                icon: UIImagePathController.citiesByColor[playerColor],
                subIcon: ImageMetropolisPolitics,
            }
        case 'MetropolisScience':
            return {
                victoryPointChange: 2,
                title: {key: 'strings:game.achievements.title.metropolis.Science'},
                icon: UIImagePathController.citiesByColor[playerColor],
                subIcon: ImageMetropolisScience,
            }
        case 'TradingHouse':
            return {
                title: {key: 'strings:game.achievements.title.tradingHouse'},
                subTitle: {key: 'strings:game.achievements.bottomDescription.tradingHouse'},
                icon: IconTradeHouse,
            }
        case 'Aqueduct':
            return {
                title: {key: 'strings:game.achievements.title.aqueduct'},
                subTitle: {key: 'strings:game.achievements.bottomDescription.aqueduct'},
                icon: IconAqueduct,
            }
        case 'Fortress':
            return {
                title: {key: 'strings:game.achievements.title.fortress'},
                subTitle: {key: 'strings:game.achievements.bottomDescription.fortress'},
                icon: IconFortress,
            }
    }
}
